import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withModifiers as _withModifiers, isRef as _isRef, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { for: "hr_parent_sector" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = { for: "name" }

import SectorAutocomplete from "./SectorAutocomplete.vue";
import { useUpdateSector } from "./hooks/useUpdateSector";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateSector',
  setup(__props) {

const { form, disableSubmit, loading, visible, close, submit, openUpdate } =
  useUpdateSector();

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ openUpdate: _unref(openUpdate) }))),
    _createVNode(_component_Dialog, {
      visible: _unref(visible),
      "onUpdate:visible": [
        _cache[4] || (_cache[4] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
        _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
      ],
      style: { width: '450px' },
      closable: true
    }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("update.title")), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('close'),
          icon: "pi pi-times",
          onClick: _unref(close),
          class: "p-button-warning"
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          loading: _unref(loading),
          disabled: _unref(disableSubmit),
          label: _ctx.$t('modify'),
          icon: "pi pi-save",
          "icon-pos": "right",
          onClick: _unref(submit)
        }, null, 8, ["loading", "disabled", "label", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", {
          autocomplete: "off",
          class: "p-fluid",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("hr_parent_sector")), 1),
            _createVNode(SectorAutocomplete, {
              id: "hr_parent_sector",
              "exclude-id": _unref(form).id.$value,
              modelValue: _unref(form).parentId.$value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).parentId.$value) = $event))
            }, null, 8, ["exclude-id", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("activity.name")), 1),
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: _unref(form).name.$value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).name.$value) = $event)),
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_unref(form).name.$validate())),
              class: _normalizeClass({ 'p-invalid': _unref(form).name.$hasError })
            }, null, 8, ["modelValue", "class"])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})